export default class AudioService {

	constructor (vue) {
		this.vue = vue
		this.audioCtx = null
		this.scriptProcessorAnalysisNode = null
		this.mediaRecorder = null
		this.onStart = () => {}
		this.onTick = () => {}
		this.onStop = () => {}
		this.onSuccess = () => {}
		this.onError = () => {}
		this.onValues = () => {}
	}

	startRecording (duration = 10) {
		navigator.mediaDevices.getUserMedia({ audio: true })
			.then(stream => {
				this.mediaRecorder = new MediaRecorder(stream)
				this.vue.$log.info('audio service', this.mediaRecorder.mimeType)()

				//this.processAudio(stream)

				this.mediaRecorder.start()
				this.onStart()
				this.vue.$log.info('audio service', 'recording...')()

				const audioChunks = []
				this.mediaRecorder.addEventListener('dataavailable', event => {
					audioChunks.push(event.data)
				})

				this.mediaRecorder.addEventListener('stop', () => {
					this.vue.$log.info('audio service', '...stop')()
					const audioBlob = new Blob(audioChunks, {type: 'audio/webm'})

					/*const audioUrl = window.URL.createObjectURL(audioBlob)
					const audio = new Audio(audioUrl)
					console.log('playback')
					audio.play()*/

					/*const link = document.createElement('a')
					link.href = window.URL.createObjectURL(audioBlob)
					link.download = 'audio.webm'
					link.click()*/

					this.uploadFile(audioBlob)

					this.onStop()
				})

				if (duration > 0) {
					setTimeout(() => {
						this.stopRecording()
					}, duration * 1000)
				}
			})
			.catch(error => {
				this.vue.$log.error('audio service', `${error.name}: ${error.message}`)()
				this.onError(error)
			})
	}

	stopRecording () {
		if (this.mediaRecorder != null && this.mediaRecorder.state === 'recording') {
			this.mediaRecorder.stop()

			//this.scriptProcessorAnalysisNode.disconnect(this.audioCtx.destination)
		}
	}

	uploadFile (file) {
		this.vue.$api.files.uploadBlob(this.vue, this.vue.user_uid, this.vue.watch_id, file)
			.then(response => {
				this.vue.$log.info('audio service', 'files.upload OK', response)()
				this.onSuccess(response.body.uid)
			})
			.catch(error => {
				this.vue.$log.error('audio service', 'files.upload ERROR', error)()
				this.onError(error)
			})
	}

	processAudio (stream) {
		this.audioCtx = new (window.AudioContext || window.webkitAudioContext)()

		const micStream = this.audioCtx.createMediaStreamSource(stream)

		this.scriptProcessorAnalysisNode = this.audioCtx.createScriptProcessor(4096, 1, 1)
		this.scriptProcessorAnalysisNode.connect(this.audioCtx.destination)

		const analyser = this.audioCtx.createAnalyser()
		//analyser.smoothingTimeConstant = 0
		analyser.fftSize = 32

		micStream.connect(analyser)

		analyser.connect(this.scriptProcessorAnalysisNode)

		let arrayFreqDomain = new Float32Array(analyser.frequencyBinCount)
		let arrayTimeDomain = new Float32Array(analyser.fftSize)

		this.scriptProcessorAnalysisNode.onaudioprocess = () => {
			analyser.getFloatFrequencyData(arrayFreqDomain)
			analyser.getFloatTimeDomainData(arrayTimeDomain)
			//console.log(arrayTimeDomain)
			this.onValues(Array.from(arrayTimeDomain))
		}
	}

	initProcessor () {
		navigator.mediaDevices.getUserMedia({ audio: true })
			.then(stream => {
				this.processAudio(stream)
			})
			.catch(error => {
				this.vue.$log.error('audio service', `${error.name}: ${error.message}`)()
				this.onError(error)
			})
	}
}



// WEBPACK FOOTER //
// ./src/services/AudioService.js